import React from 'react'

function Step4() {
  return (
    <div>Step4</div>
  )
}

export default Step4